<template>
  <div>
    <div class="position-relative mb-3">
      <div class="position-relative mb-3">
        <section class="section-profile-cover section-shaped my-0">
          <div
            class="shape shape-style-1 bg-gradient-darkgray shape-skew alpha-4"
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </section>
        <section class="section-skew">
          <div class="container-section">
            <card shadow class="section-home">
              <div class="row row-grid align-items-center">
                <div
                  class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 text-right"
                >
                  <div class="title-product">
                    <h3>
                      هیگل چیست؟
                    </h3>

                    <p>
                      سامانه درخواست خدمات پزشکی از خانه سرمد
                    </p>
                    <p>
                      هیگل یک سامانه درخواست خدمات پزشکی در منزل است که شامل
                      خدمات پزشکی، درمانی، آزمایشگاهی و پرستاری است که بر خلاف
                      آنچه در مراکز درمانی عمومی مانند کلینیک‌ها یا خانه‌های
                      سالمندان رخ می‌دهد، توسط یک فرد حرفه‌ای در منزل فردی که
                      بیمار یا مراجعه کننده در آن زندگی می کند ارائه می شود. از
                      دیگر قابلیت‌های هیگل همچنین می‌توان به مجموعه‌ای از
                      فعالیت‌های پیراپزشکی در زندگی روزمره برای بیماران، معلولان
                      یا افراد مسن نام برد.
                    </p>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="img-main-page">
                    <img src="img/product/prescription-bro.svg" alt="" />
                  </div>
                </div>
              </div>
            </card>
          </div>
        </section>
      </div>
      <section class="section-tab-product">
        <div class="container-section">
          <tabs :fill="false" class="flex-column">
            <tab-pane key="tab1" class="section-product">
              <template slot="title">
                <h5>
                  بیمارستان در خانه (HITH)
                </h5>
              </template>

              <b-row>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <p>
                    بیمارستان در خانه (HITH) مراقبتی بالینی است که طول مدت اقامت
                    در بیمارستان را کاهش داده و یا در مواردی می‌تواند به طور کلی
                    از بستری شدن جلوگیری کند. طیف وسیعی از شرایط بالینی را
                    می‌توان به طور موثر و ایمن بدون نیاز به ماندن در بیمارستان
                    مدیریت کرد. شواهد علمی وجود دارد که شرایط خاصی را می‌توان با
                    این نوع مراقبت به خوبی مدیریت کرد:
                  </p>

                  <ul>
                    <li>سلولیت</li>
                    <li>پنومونی یا سینه پهلو</li>
                    <li>ترومبوز سیاهرگی عمقی</li>
                    <li>بیماری انسدادی مزمن ریه (COPD)</li>
                    <li>عفونت‌ مجاری ادراری</li>
                  </ul>
                  <h6>
                    مراقبت‌های دریافتی از طریق خدمات بیمارستان در خانه با
                    مراقبت‌های دریافتی در بیمارستان قابل مقایسه است. برخی از
                    مزایا برای بیماران عبارتند از:
                  </h6>
                  <ul>
                    <li>توانایی ماندن در راحتی و آسایش خانه خود</li>
                    <li>
                      عدم نیاز به عادت بیمارستان و روتین‌های آن، بیماران
                      می‌توانند غذای خود را بخورند‌، وقتی که می‌خواهند تلویزیون
                      تماشا کنند و در تختخواب خود بخوابند!
                    </li>
                    <li>کاهش خطر عوارض جانبی از بستری شدن در بیمارستان</li>
                    <li>
                      دوستان و خانواده که می‌خواهند از بیمار عیادت کنند و به او
                      سر بزنند به جابی آنکه با برنامه بیمارستان هماهنگ شوند، با
                      خود بیمار هماهنگ می‌شوند!
                    </li>
                  </ul>
                  <p>
                    این گزینه‌ها برای بیمارانی که می‌توان آن‌ها در خانه‌هایشان
                    درمان کرد، باعث می‌شود ماندن غیر ضروری بیمار در بیمارستان
                    جلوگیری شود و اطمینان حاصل شود که تخت‌هایی برای بیمارانی که
                    برای مراقبت از آ‌ن‌ها نیاز به بستری شدن در بیمارستان است،
                    وجود دارد.
                  </p>
                  <p>
                    هیگل تعداد متنوعی از خدمات HITH را در خود جای داده است. این
                    خدمات نام‌های متفاوتی دارند و شرایط متفاوتی را مدیریت
                    می‌کنند‌، بنابراین همیشه بهتر است با پزشک خود در مورد اینکه
                    آیا این یک گزینه برای شما است صحبت کنید.
                  </p>
                  <p>
                    علیرغم تمامی تفاوت‌ها‌، آنچه در هیگل یکسان است، این است که
                    شما می‌توانید مراقبت‌های پزشکی و درمانی مورد نیاز خود را با
                    کیفیت بالا و بدون نیاز به بستری شدن در بیمارستان دریافت
                    کنید.
                  </p>
                  <p>
                    دفعه بعد که در بیمارستان هستید، از پزشک خود بپرسید که آیا
                    وضعیت شما می‌تواند در خانه درمان شود. ممکن است بتوانید تمام
                    یا بخشی از مراقبت‌های مورد نیاز خود را در حالی که در آسایش
                    خانه خودتان هستید دریافت کنید.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pl-0"
                >
                  <div class="img-tab">
                    <img src="img/product/Doctor-amico.svg" alt="" />
                  </div>
                </b-col>
              </b-row>
            </tab-pane>

            <tab-pane key="tab2" class="section-product">
              <template slot="title">
                <h5>
                  راهنمای بیمارستان در خانه هیگل
                </h5>
              </template>
              <b-row>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <p>
                    HITH یک برنامه جایگزینی بیمارستان است به این معنی که فردی که
                    این خدمت را دارد مجبور نیست در بیمارستان بماند. قابلیت‌های
                    موجود در هیگل بر اساس نیازها و بدون در نظر گرفتن سن‌،
                    ناتوانی‌، جغرافیا‌، فرهنگ یا جنسیت در دسترس است. هدف این است
                    که مراقبتی بیمار محور را تا آنجا که ممکن است نزدیک خانه
                    ارائه شود.
                  </p>
                  <p>
                    دستورالعمل بیمارستان در خانه‌ی هیگل توسط پزشکان تهیه شده است
                    تا راهنمای استاندارد و مشخصی را برای تمامی کسانی در مناطق
                    مختلف از این سامانه استفاده می‌کنند داشته باشد، عناصر کلیدی
                    و اصول HITH با بروزترین اطلاعات تکنولوژیک و پزشکی گردآوری
                    شده است.
                  </p>
                  <ul>
                    <li>
                      مشتریانی که مراقبت‌های درمانی خانگی دریافت می‌کنند ممکن
                      است هزینه‌های کمتری را متحمل شوند‌، به همان اندازه
                      مراقبت‌های بهتری دریافت کنند و رضایت بیشتری از خدمات ارایه
                      شده داشته باشند.
                    </li>
                    <li>
                      گاهی اوقات‌، می‌توان مراقبت‌های تسکینی و پایان عمر را از
                      طریق پرستاری بهداشت خانگی ارائه کرد که برای آرامش بیمار
                      بسیار حایز اهمیت است.
                    </li>
                    <li>
                      پرستاران حرفه‌ای ممکن است به بیماران در فعالیت‌های روزمره
                      زندگی (ADLs) مانند حمام کردن‌، توالت رفتن و تغذیه کمک
                      کنند، یا حامیان بیمار را در ارائه مراقبت‌های ADL راهنمایی
                      و نظارت کنند. این کار منجر به ایجاد آرامش بیشتر برای بیمار
                      و همراهان او می‌شود.
                    </li>
                    <li>
                      پرستاران علائم حیاتی را پیگیری می کنند‌، دستورات پزشک را
                      انجام می‌دهند ، خون می‌گیرند و دیگر خدمات پزشکی را که
                      ارایه می‌دهند، در نهایت می‌توان گفت که وضعیت سلامتی بیمار
                      به طور کامل ثبت می‌کنند. با بررسی این اطلاعات به می‌توانند
                      قبل ظهور علایم بیماری‌ها و مشکلات را پیش بینی کنند و به
                      درمان آن‌ها بپردازند.
                    </li>
                    <li>
                      در شرایطی که نمی‌شود بیمار را جابه‌جا کرد، می‌شود خدمات
                      آزمایشگاهی نظیر تصویر برداری اشعه ایکس را به خانه بیمار
                      آورد و این خدمات را در خانه برای بیمار انجام داد.
                    </li>
                    <li>
                      با سامانه درخواست خدمات پزشکی بین بیمار‌، خانواده و پزشک
                      یا گروه درمان ارتباط بیشنر و با کیفیت‌تری برقرار می‌شود.
                    </li>
                  </ul>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pl-0"
                >
                  <div class="img-tab">
                    <img src="img/product/Doctor-cuate.svg" alt="" />
                  </div>
                </b-col>
              </b-row>
            </tab-pane>

            <tab-pane key="tab3" class="section-product">
              <template slot="title">
                <h5>
                  ویژگی‌های هیگل
                </h5>
              </template>

              <b-row>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <p>
                    طیف وسیعی از خدمات مراقبت‌های بهداشتی خانگی وجود دارد که
                    بیمار می‌تواند در خانه دریافت کند. بسته به وضعیت هر بیمار‌،
                    مراقبت می‌تواند از مراقبت‌های پرستاری گرفته تا خدمات پزشکی
                    تخصصی و خدمات آزمایشگاهی متغیر باشد. بیمار و پزشک برنامه
                    مراقبت و خدمات مورد نیاز را در خانه تعیین می‌کنند. خدمات
                    مراقبت در خانه ممکن است شامل موارد زیر باشد:
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>مراقبت‌های پزشکی :</h6>
                  <p>
                    پزشک ممکن است برای تشخیص و درمان بیماری (ها) از بیمار در
                    منزل ویزیت کند. او همچنین ممکن است به طور دوره‌ای نیازهای
                    مراقبت‌های بهداشتی و درمانی خانگی را بررسی کند.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>مراقبت های پرستاری :</h6>
                  <p>
                    متداول ترین نوع مراقبت‌های بهداشتی خانگی بسته به نیازهای
                    شخص، مراقبت پرستاری است. با مشورت پزشک، یک پرستار برنامه
                    مراقبتی را اجرا می کند. مراقبت‌های پرستاری ممکن است شامل
                    پانسمان زخم، مراقبت استومی ، تزریق وریدی، نظارت بر سلامت
                    عمومی بیمار، کنترل درد و سایر حمایت‌های بهداشتی باشد.
                  </p>
                </b-col>

                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pl-0"
                >
                  <h6>فیزیوتراپی ، کار و/یا گفتاردرمانی :</h6>
                  <p>
                    برخی از بیماران ممکن است به آموزش مجدد نحوه انجام وظایف
                    روزانه یا بهبود گفتار خود پس از بیماری یا آسیب دیدگی نیاز
                    داشته باشند. یک فیزیوتراپ می‌تواند برنامه مراقبتی را برای
                    کمک به بیمار برای بازیابی یا تقویت استفاده از ماهیچه ها و
                    مفاصل تنظیم کند. یک کاردرمانگر می‌تواند به بیمار مبتلا به
                    ناتوانی جسمی‌، رشدی‌، اجتماعی یا عاطفی کمک کند تا نحوه انجام
                    کارهای روزانه مانند غذا خوردن‌، حمام کردن‌، لباس پوشیدن و
                    موارد دیگر را یاد بگیرد. یک گفتاردرمانگر می تواند به بیمار
                    مبتلا به اختلال گفتاری کمک کند تا توانایی برقراری ارتباط
                    واضح را بازیابد.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>خدمات پزشکی اجتماعی :</h6>
                  <p>
                    مددکاران اجتماعی خدمات مختلفی را به بیمار ارائه می‌دهند‌، از
                    جمله مشاوره و تعیین منابع اجتماعی برای کمک به بیمار در
                    بهبودی وی. برخی از مددکاران اجتماعی نیز مدیر پرونده بیمار
                    هستند-اگر وضعیت پزشکی بیمار بسیار پیچیده است و نیاز به
                    هماهنگی بسیاری از خدمات دارد.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>مراقبت از دستیاران بهداشت خانه :</h6>
                  <p>
                    دستیاران بهداشت خانه می توانند به بیمار در مورد نیازهای
                    اولیه شخصی خود مانند برخاستن از رختخواب ، راه رفتن ، حمام و
                    لباس پوشیدن کمک کنند. برخی از دستیاران آموزش های تخصصی را
                    برای کمک به مراقبت های تخصصی تر زیر نظر پرستار آموزش دیده
                    اند.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>خانه دار با ارایه مراقبت‌های اولیه :</h6>
                  <p>
                    در حالی که بیمار در خانه تحت مراقبت پزشکی قرار می‌گیرد‌،
                    خانه دار یا شخصی که در کارهای خانه یا کارهای شخصی کمک می‌کند
                    می‌تواند در خانه با ارایه خدماتی نظیر تهیه غذا، تمیزکردن
                    خانه، شست و شوی البسه، خرید مواد غذایی و سایر خدمات
                    خانه‌داری به بیمار کمک کند.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>همراهی – مصاحبت :</h6>
                  <p>
                    برخی از بیمارانی که تنها در خانه هستند ممکن است برای همراهی
                    و آسایش و نظارت به همراه نیاز داشته باشند. برخی از همراهان
                    ممکن است وظایف خانه را نیز انجام دهند.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>مراقبت داوطلبانه :</h6>
                  <p>
                    داوطلبان از سازمان‌های اجتماعی می‌توانند از طریق همراهی‌،
                    کمک به مراقبت شخصی‌، ارائه خدمات حمل و نقل‌، حمایت عاطفی
                    و/یا کمک به کارهای اداری‌، آسایش اولیه را به بیماری که نیاز
                    به این موارد را دارد، ارائه دهند.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>حمایت تغذیه‌ای :</h6>
                  <p>
                    متخصصان تغذیه می‌توانند به خانه بیمار بیایند تا ارزیابی رژیم
                    غذایی و راهنمایی برای حمایت از برنامه درمان را ارائه دهند.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>تصویربرداری اشعه ایکس و خدمات آزمایشگاهی : :</h6>
                  <p>
                    برخی آزمایشات آزمایشگاهی مانند آزمایش خون و ادرار را می‌توان
                    در آسایش خانه بیمار انجام داد. علاوه بر این‌، دستگاه های
                    قابل حمل اشعه ایکس به تکنسین‌های آزمایشگاه این امکان را
                    می‌دهند تا این سرویس را در خانه انجام دهند.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>خدمات دارویی</h6>
                  <p>
                    دارو و تجهیزات پزشکی را می‌توان در خانه تحویل داد. در صورت
                    نیاز بیمار‌، می‌توان در مورد نحوه مصرف داروها یا استفاده از
                    تجهیزات‌، از جمله تزریقات وریدی آموزش داد.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>حمل و نقل :</h6>
                  <p>
                    شرکت‌هایی هستند که به بیمارانی که برای درمان یا معاینه
                    فیزیکی نیاز به رفت و آمد به مراکز درمانی دارند‌، خدمات حمل و
                    نقل مخصوص ارائه می‌دهند.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>غذاهای تحویل شده در خانه :</h6>
                  <p>
                    این خدمت برای بیمارانی که است که در خانه قادر به پختن غذا
                    نیستند. بسته به نیاز فرد‌، وعده‌های غذایی گرم را می‌توان
                    چندین بار در هفته تحویل داد.
                  </p>
                </b-col>
              </b-row>
            </tab-pane>

            <tab-pane key="tab4" class="section-product">
              <template slot="title">
                <h5>
                  مزایای مراقبت در خانه (Homecare)
                </h5>
              </template>
              <b-row>
                <b-col
                  cols="12"
                  xl="12"
                  lg="12"
                  md="12"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <ul class="list-unstyled  list-tab mt-4">
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          مشتریانی که مراقبت‌های درمانی خانگی دریافت می‌کنند
                          ممکن است هزینه‌های کمتری را متحمل شوند‌، به همان
                          اندازه مراقبت‌های بهتری دریافت کنند و رضایت بیشتری از
                          خدمات ارایه شده داشته باشند.
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          گاهی اوقات‌، می‌توان مراقبت‌های تسکینی و پایان عمر را
                          از طریق پرستاری بهداشت خانگی ارائه کرد که برای آرامش
                          بیمار بسیار حایز اهمیت است.
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          پرستاران حرفه‌ای ممکن است به بیماران در فعالیت‌های
                          روزمره زندگی (ADLs) مانند حمام کردن‌، توالت رفتن و
                          تغذیه کمک کنند، یا حامیان بیمار را در ارائه مراقبت‌های
                          ADL راهنمایی و نظارت کنند. این کار منجر به ایجاد آرامش
                          بیشتر برای بیمار و همراهان او می‌شود.
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          پرستاران علائم حیاتی را پیگیری می کنند‌، دستورات پزشک
                          را انجام می‌دهند ، خون می‌گیرند و دیگر خدمات پزشکی را
                          که ارایه می‌دهند، در نهایت می‌توان گفت که وضعیت سلامتی
                          بیمار به طور کامل ثبت می‌کنند. با بررسی این اطلاعات به
                          می‌توانند قبل ظهور علایم بیماری‌ها و مشکلات را پیش
                          بینی کنند و به درمان آن‌ها بپردازند.
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          در شرایطی که نمی‌شود بیمار را جابه‌جا کرد، می‌شود
                          خدمات آزمایشگاهی نظیر تصویر برداری اشعه ایکس را به
                          خانه بیمار آورد و این خدمات را در خانه برای بیمار
                          انجام داد.
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          با سامانه درخواست خدمات پزشکی بین بیمار‌، خانواده و
                          پزشک یا گروه درمان ارتباط بیشنر و با کیفیت‌تری برقرار
                          می‌شود.
                        </h5>
                      </div>
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </tab-pane>
            <tab-pane key="tab5" class="section-product">
              <template slot="title">
                <h5>
                  سطوح خدمات
                </h5>
              </template>
              <b-row>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>نرم افزاری</h6>
                  <p>
                    هیگل برای پزشکان، پرستاران، مدیریان مراکز درمانی و بیماران
                    از امکانات نرم افزاری پرکاربرد تعبیه کرده است. پرونده پزشکی
                    کامل بیمار، درخواست پزشک یا پرستار توسط بیمار و یا دیدن
                    تمامی نمودارهای عملکردی برای مدیران به سادگی در دسترس است
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>سخت افزاری</h6>
                  <p>
                    هیگل به تکنسین‌های اشعه ایکس و موسسات آزمایشگاهی این امکان
                    را می‌‌دهد تا با درخواست بیمار و تایید پزشک در خانه بیمار
                    حاضر شوند و آزمایش‌های لازم و مورد نیاز پزشک معالج را از
                    بیمار بگیرند.
                  </p>
                </b-col>
              </b-row>
            </tab-pane>
            <tab-pane key="tab6" class="section-product">
              <template slot="title">
                <h5>
                  اهداف
                </h5>
              </template>
              <b-row>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <p>
                    با هدف ارایه بالاترین کیفیت خدمات درمانی برای کسانی که دوست
                    دارند در خانه درمان بشوند، مورد مراقبت پزشکی و یا پرستاری
                    قرار بگیرند، خانواده‌هایی که دوست دارند فردی از خانواده که
                    نیاز به خدمات درمانی و بهداشتی دایمی دارد در خانه باشد
                    مدیرانی که برای کاهش هزینه‌های کلینک خود و همچنین وسعت
                    بخشیدن به خدماتی که ارایه می‌دهند، سرمد این سامانه را طراحی
                    کرده است. به وسیله هیگل بسیاری از بیماران دایم در حال
                    مانیتور شدن توسط پزشکان هستند در حالی که با آسایش در خانه
                    خود وقت می‌گذرانند.
                  </p>
                </b-col>
              </b-row>
            </tab-pane>
            <tab-pane key="tab7" class="section-product">
              <template slot="title">
                <h5>
                  چرا هیگل
                </h5>
              </template>
              <b-row>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>
                    دلایلی که ما هیگل را بهترین سامانه پزشکی و مراقبت در خانه
                    می‌دانیم …
                  </h6>

                  <p>
                    هیگل در یک کلام کامل است. نه تنها بیماران می‌توانند بالاترین
                    دسترسی به اطلاعات در مورد بیماری و وضعیت خود را داشته باشند،
                    پزشکان کاملترین پرونده‌ی پزشکی ممکن از بیمار خود را همواره
                    در اختیار دارند و علایم بیمار در صورت نیاز به صورت مدام برای
                    آن‌ها بروزرسانی می‌شود و مدیران به سادگی برای تمامی
                    فعالیت‌های انجام شده گزارش دریافت می‌کنند. این بدین معناست
                    که تمامی نقش‌های درگیر در طی عمیات درمان با هم در ارتباط
                    هستند، از نیازهای همدیگر اطلاع دارند و برای پیشبرد اهداف که
                    تضمین سلامت بیمار است همکاری می‌کنند.
                  </p>
                </b-col>
              </b-row>
            </tab-pane>
          </tabs>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import moment from "moment-jalaali";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";
import { slider, slideritem } from "vue-concise-slider";
import { LMap, LTileLayer } from "vue2-leaflet";
import "hooper/dist/hooper.css";
import {
  Hooper,
  Slide,
  Progress as HooperProgress,
  Pagination as HooperPagination,
  Navigation as HooperNavigation,
} from "hooper";
export default {
  name: "Heagle",
  components: {
    datePicker: VuePersianDatetimePicker,
    Tabs,
    TabPane,
    slider,
    slideritem,
    Hooper,
    Slide,
    HooperProgress,
    HooperPagination,
    HooperNavigation,
    LMap,
    LTileLayer,
  },
  data() {
    return {
      slide: 0,
      sliding: null,

      listSlider: [
        {
          src: "img/images/helpimg.jpg",
          name: "قشم",
          time: "4",
          month: "فروردین",
          price: "200000",
        },
        {
          src: "img/images/helpimg.jpg",
          name: "کیش",
          time: "4",
          month: "فروردین",
          price: "200000",
        },
        {
          src: "img/images/helpimg.jpg",
          name: "تپه های مریخی تا تونل نمکی",
          time: "4",
          month: "فروردین",
          price: "200000",
        },
        {
          src: "img/images/helpimg.jpg",
          name: "یزد",
          time: "4",
          month: "فروردین",
          price: "200000",
        },
        {
          src: "img/images/helpimg.jpg",
          name: "گیلان",
          time: "4",
          month: "فروردین",
          price: "200000",
        },
        {
          src: "img/images/helpimg.jpg",
          name: "یزد",
          time: "4",
          month: "فروردین",
          price: "200000",
        },
        {
          src: "img/images/helpimg.jpg",
          name: "گیلان",
          time: "4",
          month: "فروردین",
          price: "200000",
        },
        {
          src: "img/images/helpimg.jpg",
          name: "یزد",
          time: "4",
          month: "فروردین",
          price: "200000",
        },
        {
          src: "img/images/helpimg.jpg",
          name: "گیلان",
          time: "4",
          month: "فروردین",
          price: "200000",
        },
        {
          src: "img/images/helpimg.jpg",
          name: "یزد",
          time: "4",
          month: "فروردین",
          price: "200000",
        },
        {
          src: "img/images/helpimg.jpg",
          name: "گیلان",
          time: "4",
          month: "فروردین",
          price: "200000",
        },
        {
          src: "img/images/helpimg.jpg",
          name: "یزد",
          time: "4",
          month: "فروردین",
          price: "200000",
        },
      ],
      someListlid: [
        {
          html: "slider1",
          style: {
            background: "#4abf8a",
            width: "600px",
          },
        },
        {
          html: "slider2",
          style: {
            background: "#4bbfc3",
            width: "600px",
          },
        },
        {
          html: "slider3",
          style: {
            background: "#7baabe",
            width: "600px",
          },
        },
        {
          html: "slide4",
          style: {
            background: "#4abf8a",
            width: "600px",
          },
        },
        {
          html: "slide5",
          style: {
            background: "#4bbfc3",
            width: "600px",
          },
        },
        {
          html: "slide6",
          style: {
            background: "#7baabe",
            width: "600px",
          },
        },
      ],
      optionsslide: {
        currentPage: 0,
        speed: 300,
        itemAnimation: true,
        centeredSlides: true,
        thresholdDistance: 100,
        thresholdTime: 300,
        loopedSlides: 2,
        slidesToScroll: 1,
        loop: true,
      },
      someList: [
        {
          img: "img/service/Cross-platform software-pana.svg",
        },
        {
          img: "img/service/Low code development-pana.svg",
        },
        {
          img: "img/service/Mobile testing-pana.svg",
        },
      ],
      optionslide: {
        currentPage: 3,
      },
      listReserve: [
        {
          src: "img/images/helpimg.jpg",
        },
        {
          src: "img/images/helpimg.jpg",
        },
        {
          src: "img/images/helpimg.jpg",
        },
        {
          src: "img/images/helpimg.jpg",
        },
      ],
      optionListReserv: {
        currentPage: 3,
      },
      sliderJobs: [
        {
          html: "slide1",
          style: {
            background: "#1bbc9b",
          },
        },
        {
          html: "slide2",
          style: {
            background: "#4bbfc3",
          },
        },
        {
          html: "slide3",
          style: {
            background: "#7baabe",
          },
        },
        {
          html: "slide4",
          style: {
            background: "#7baabe",
          },
        },
        {
          html: "slide5",
          style: {
            background: "#7baabe",
          },
        },
      ],
      selecteTourCategory: null,
      optionTourCategory: [
        { value: null, text: "دسته بندی" },
        { value: "a", text: " ساحلی" },
        { value: "b", text: "اموزشی" },
        { value: "c", text: "کمپ" },
      ],
      selecteTour: null,
      optionTour: [
        { value: null, text: "نوع تور" },
        { value: "a", text: "هر دو" },
        { value: "b", text: "خارجی" },
        { value: "c", text: "داخلی" },
      ],
      selecteOrganizer: null,
      optionOrganizer: [
        { value: null, text: "برگزارکننده" },
        { value: "a", text: "یاترا" },
        { value: "b", text: "یاترا دوم" },
      ],
      selecteEventCategory: null,
      optionEventCategory: [
        { value: null, text: "دسته بندی" },
        { value: "a", text: " ساحلی" },
        { value: "b", text: "اموزشی" },
        { value: "c", text: "کمپ" },
      ],
      selecteEvent: null,
      optionEvent: [
        { value: null, text: "نوع برگزاری رویداد" },
        { value: "a", text: "هر دو" },
        { value: "b", text: "انلاین" },
        { value: "c", text: "حضوری" },
      ],
      selecteEventType: null,
      optionEventType: [
        { value: null, text: " نوع رویداد" },
        { value: "a", text: "تخصصی" },
        { value: "b", text: "عمومی" },
      ],
      selectedorigin: null,
      optionsorigin: [
        { value: null, text: "شهر مبدا" },
        { value: "a", text: "تهران" },
        { value: "b", text: "کرج" },
      ],
      selecteddestination: null,
      optionsdestination: [
        { value: null, text: "شهر مقصد" },
        { value: "a", text: "تهران" },
        { value: "b", text: "کرج" },
      ],
      selectedNumber: null,
      optionsNumber: [
        { value: null, text: "تعداد شب" },
        { value: "a", text: "This is First option" },
        { value: "b", text: "Selected Option" },
        { value: { C: "3PO" }, text: "This is an option with object value" },
        { value: "d", text: "This one is disabled", disabled: true },
      ],
      organizers: [
        {
          src: "img/theme/team-1-800x800.jpg",
          name: "ماهور فریمان",
          text: "توضیحات",
        },
        {
          src: "img/theme/team-2-800x800.jpg",
          name: "ماهور فریمان",
          text: "توضیحات",
        },
        {
          src: "img/theme/team-3-800x800.jpg",
          name: "ماهور فریمان",
          text: "توضیحات",
        },
        {
          src: "img/theme/team-4-800x800.jpg",
          name: "ماهور فریمان",
          text: "توضیحات",
        },
      ],
      moment: moment,
      startDate: "",
      endDate: "",
    };
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>
